import { SET_MEMBER, CLEAR_MEMBER, SET_OVER_YEAR_OTP } from './mutations';

export const actions = {
    setMember({ commit }, payload) {
        commit(SET_MEMBER, payload);
    },
    clearMember({ commit }) {
        commit(CLEAR_MEMBER);
    },
    setOverYearOtp({ commit }, payload) {
        commit(SET_OVER_YEAR_OTP, payload);
    },
    clearOverYearOtp({ commit }) {
        commit(SET_OVER_YEAR_OTP, {
            chooseWay: '', // 選擇的項目
            contact: '', // 聯絡號碼或是email
        });
    },
};
